import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["containerStyle", "onResize", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import rafSchedule from 'raf-schd';
var containerDivStyle = {
  width: '100%',
  position: 'relative'
};

// Not using styled-components here for performance
// and framework-agnostic reasons.
var sizerStyle = {
  display: 'block',
  position: 'absolute',
  top: 0,
  left: 0,
  height: 0,
  width: '100%',
  opacity: 0,
  overflow: 'hidden',
  pointerEvents: 'none',
  zIndex: -1
};

// add a definition for a data field to the resize object
// since HTMLElements do not have this.
/**
 * @deprecated use WidthObserver instead
 *
 * This component uses iframes for rendering and is currently
 * not performant. It will be DEPRECATED in the future.
 * It is recommended that you instead use WidthObserver from @atlaskit/width-detector
 */
var WidthDetector = /*#__PURE__*/function (_React$Component) {
  _inherits(WidthDetector, _React$Component);
  var _super = _createSuper(WidthDetector);
  function WidthDetector(props) {
    var _this;
    _classCallCheck(this, WidthDetector);
    _this = _super.call(this, props);

    // eslint-disable-next-line no-console
    _defineProperty(_assertThisInitialized(_this), "state", {});
    _defineProperty(_assertThisInitialized(_this), "handleResize", rafSchedule(function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
        container = _assertThisInitialize.container;
      if (!container) {
        return;
      }
      var width = container.offsetWidth;
      _this.setState({
        width: width
      });
      if (_this.props.onResize) {
        _this.props.onResize(width);
      }
    }));
    _defineProperty(_assertThisInitialized(_this), "handleContainerRef", function (ref) {
      if (!ref) {
        return;
      }
      _this.container = ref;
    });
    _defineProperty(_assertThisInitialized(_this), "handleObjectRef", function (ref) {
      if (!ref) {
        return;
      }
      _this.resizeObject = ref;
    });
    _defineProperty(_assertThisInitialized(_this), "handleObjectLoad", function () {
      if (!_this.resizeObject) {
        return;
      }
      _this.resizeObjectDocument = _this.resizeObject.contentDocument.defaultView;
      _this.resizeObjectDocument.addEventListener('resize', _this.handleResize);
      _this.handleResize();
    });
    console.warn('WidthDetector will be deprecated, please use WidthObserver from @atlaskit/width-detector instead.');
    return _this;
  }
  _createClass(WidthDetector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.resizeObject) {
        this.resizeObject.data = 'about:blank';
      }
      // Calculate width first time, after object has loaded.
      // Prevents it from getting in a weird state where width is always 0.
      this.handleResize();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleResize.cancel();
      if (this.resizeObjectDocument) {
        this.resizeObjectDocument.removeEventListener('resize', this.handleResize);
      }
    }
  }, {
    key: "render",
    value: function render() {
      // @TODO: Add alternative method using IntersectionObserver or ResizeObserver

      var sizerEl = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("object", {
        type: "text/html",
        style: sizerStyle,
        ref: this.handleObjectRef,
        onLoad: this.handleObjectLoad,
        "aria-hidden": true,
        tabIndex: -1
      }));
      // pluck non-DOM props off the props so we can safely spread remaining items
      var _this$props = this.props,
        containerStyle = _this$props.containerStyle,
        onResize = _this$props.onResize,
        children = _this$props.children,
        props = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement("div", _extends({}, props, {
        style: _objectSpread(_objectSpread({}, containerDivStyle), containerStyle),
        ref: this.handleContainerRef
      }), children(this.state.width), sizerEl);
    }
  }]);
  return WidthDetector;
}(React.Component);
_defineProperty(WidthDetector, "defaultProps", {
  containerStyle: {}
});
export { WidthDetector as default };